import { FC } from 'react';
import { SignPage } from './sign.component';
import { ESignTypes } from '../types';

interface IProps {}

export const SignUpPage: FC<IProps> = () => <SignPage type={ESignTypes.SIGN_UP} />;
